var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaroRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 39,
    transform: "rotate(-180 43 43)",
    fill: "#F3F9FB",
    stroke: "white",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.556 29.717C36.1628 30.1103 35.9419 30.6436 35.9419 31.1997C35.9419 31.7559 36.1628 32.2892 36.556 32.6825L46.9376 43.0641L36.556 53.4457C36.174 53.8413 35.9626 54.371 35.9674 54.9209C35.9721 55.4708 36.1927 55.9969 36.5816 56.3857C36.9704 56.7746 37.4964 56.9951 38.0463 56.9999C38.5962 57.0047 39.126 56.7933 39.5216 56.4113L51.3859 44.5469C51.7791 44.1536 52 43.6202 52 43.0641C52 42.508 51.7791 41.9746 51.3859 41.5813L39.5216 29.717C39.1283 29.3238 38.5949 29.1029 38.0388 29.1029C37.4827 29.1029 36.9493 29.3238 36.556 29.717Z",
    fill: "#2ECC40"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaroRight);
export default __webpack_public_path__ + "static/media/caroRight.8700277f8d1003f3025389003bc53007.svg";
export { ForwardRef as ReactComponent };